import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { SubscriptionPlan } from '@fitness-force/models';

import { environment } from '@fitness-force/environments';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class TaxGroupService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getTaxGroups(tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TAX.GET_TAX_GROUPS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getAggregatedTaxGroups() {
    return this.http
      .get(
        `${environment.BASE_URL}/distinct_tax_groups`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
